import styled from 'styled-components';

export const MentionContainer = styled.span`
  display: inline-flex;
  vertical-align: middle;
  padding: 1px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  cursor: pointer;

  .identifier {
    display: flex;
    flex-direction: row;
    align-items: center;

    text-decoration: none;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.primary.primary};
  }

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary.primary}26`};
    color: ${({ theme }) => theme.colors.primary.primary};
  }
`;

export const ContainerTooltip = styled.div`
  width: 200px;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  .contentTooltip {
    display: flex;
    flex-direction: column;

    .name {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
    }

    .email {
      font-size: 10px;
      font-weight: 400;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }
  }
`;
